<template lang="html">
<div>
  <div id="pdf">


    <table id="table">
      <tr>
        <th>Zaposleni</th>
        <th>Podredjeni</th>
        <th>Nadredjeni</th>
        <th>Isti Nivo</th>
        <th>Ukupno</th>
      </tr>

      <tr v-for="(user,i) in usersSameCompany" :key="i">
        <td>{{user.name}}</td>
        <td>{{user.feedBackTest.prosek.podredjeni.toFixed(2)}}</td>
        <td>{{user.feedBackTest.prosek.nadredjeni.toFixed(2)}}</td>
        <td>{{user.feedBackTest.prosek.istiNivo.toFixed(2)}}</td>
        <td>{{user.feedBackTest.prosek.ukupno.toFixed(2)}}</td>
      </tr>

    </table>

  </div>
  <div class="makePdf"><button @click="makePDF">MakePDF</button></div>
</div>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import {mapActions,mapGetters} from 'vuex';
// eslint-disable-next-line no-unused-vars
import html2canvas from 'html2canvas';
// eslint-disable-next-line no-unused-vars
import jsPDF from 'jspdf';

export default {
  props:{
    company:{
      type: Object
    }
  },
computed: mapGetters(['usersSameCompany']),
  data(){
    return{
      collaguesNumber:0,
      nadredjeniUkupno:0,
      podredjeniUkupno:0,
      istiUkupno:0,
    }
  },
  methods:{
    ...mapActions(['getCollegues']),
    async makePDF() {
        await this.$nextTick();
        await document.fonts.ready;
  
        const element = document.querySelector("#pdf");
  
        const canvas = await html2canvas(element, {
          scale: 2,
          useCORS: true,
          backgroundColor: "#ffffff",
        });
  
        const pdf = new jsPDF({
          orientation: "l",
          unit: "pt",
          format: "a4",
        });
  
        const pageWidth = pdf.internal.pageSize.getWidth();
        const pageHeight = pdf.internal.pageSize.getHeight();
  
        const margin = 20;
  
        const imgWidth = pageWidth - margin * 2;
        const pageCanvasHeight =
          (pageHeight - margin * 2) * (canvas.width / imgWidth);
  
        let positionY = 0;
        let page = 0;
  
        while (positionY < canvas.height) {
          const pageCanvas = document.createElement("canvas");
          const ctx = pageCanvas.getContext("2d");
  
          pageCanvas.width = canvas.width;
          pageCanvas.height = Math.min(
            pageCanvasHeight,
            canvas.height - positionY
          );
  
          ctx.drawImage(
            canvas,
            0,
            positionY,
            canvas.width,
            pageCanvas.height,
            0,
            0,
            canvas.width,
            pageCanvas.height
          );
  
          const imgData = pageCanvas.toDataURL("image/png");
  
          if (page > 0) pdf.addPage();
  
          // 👉 NASLOV NA SVAKOJ STRANICI
          pdf.setFontSize(14);
          pdf.text("360 Feedback", margin, 15);
  
          const imgHeight =
            (pageCanvas.height * imgWidth) / canvas.width;
  
          pdf.addImage(
            imgData,
            "PNG",
            margin,
            25,
            imgWidth,
            imgHeight
          );
  
          positionY += pageCanvas.height;
          page++;
        }
  
        pdf.save("feedback360.pdf");
      },
  },
  async created(){
    await this.getCollegues(this.company.name);

  }
}
</script>

<style lang="css" scoped>
#pdf{
  background-color: #77bbff;
  border-style: solid;
  border-color: black;
  border-width: small;
  margin: 20px;
  padding: 15px;
  width: 810px;
  height: auto;
  text-align: center;
  font-family: Arial, Helvetica, sans-serif;
}

table{
  border: 2px solid black;
  text-align: center;
  margin:auto;
}
td, th{
  border: 1px solid black;
  text-align: center;
}
tr:nth-child(even){background-color: #aaaacc;}
tr:nth-child(odd){background-color: #ccccff;}
tr:hover {background-color: #afa;}

table{
    width:100%;
    border-collapse:collapse;
    table-layout:fixed;
}

td,
th{
    word-break:break-word;
    overflow-wrap:break-word;
    padding:6px;
}
.makePdf button{
    margin:15px;
    padding:5px;
  }
</style>
